export default class NewsItem {
    constructor(headline, body, date, type, link = null) {
        this.headline = headline;
        this.body = body;
        this.date = date;
        this.type = type;
        this.link = link;
    }
}
